export const CompanyStatus = Object.freeze({
    N: Symbol('N'),
    P: Symbol('P'),
    Y: Symbol('Y'),
});

/**
 * Results of this method can be used in <v-select> fields.
 */
export function getItems(value = 'value', text = 'text') {
    let items = [];
    const statuses = Object.getOwnPropertyNames(CompanyStatus);

    for (const status of statuses) {
        items.push({[value]: status, [text]: getStatusText(status)});
    }

    return items;
}

export function getStatusText(status) {
    return {
        [CompanyStatus.N]: 'Niepotwierdzona',
        [CompanyStatus.P]: 'Oczekująca',
        [CompanyStatus.Y]: 'Potwierdzona',
    }[CompanyStatus[status]];
}
